import _ from 'underscore';
import { useState } from 'vuex-composition-helpers';
import { computed, Ref, unref } from 'vue';
import { filterToProductType } from '@ve/services/productTypeConverter';
import { FilerProductType, MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';

import { AvailableProductTypes } from './types';

const filtersMappingStoreName = 'mapForFilters';

export default ({
                    availableProductTypes,
                    productType,
                }: {
    availableProductTypes: AvailableProductTypes[];
    productType: Ref<FilerProductType>;
}) => {
    const {
        products,
    } = useState<MapForFiltersState>(filtersMappingStoreName, ['products']);

    const productTypesLength = computed(() => _.mapObject(_.groupBy(unref(products), 'type'), (val) => val.length));

    const hasProductTypeToSwitchTo = computed(() => {
        const foundTypes = Object.keys(unref(productTypesLength));

        if (unref(productType) === 'all') {
            return foundTypes.length > 1;
        }

        return foundTypes.some((foundType) => foundType !== filterToProductType(unref(productType)));
    });

    const existProductTypes = computed(() => (
        _.filter(availableProductTypes, (productTypeDirection) => {
            if (productTypeDirection.type === 'tourOffer') {
                return false;
            }

            const s = filterToProductType(productTypeDirection.type);
            const type = productTypeDirection.type;
            return !!unref(productTypesLength)[s]
                || type === 'all'
                || type === unref(productType)
            
        }
    )));

    return {
        existProductTypes,
        productTypesLength,
        hasProductTypeToSwitchTo,
    };
};